export const INTEGRATIONS_API = '/api/dashboard/booking-calendar'
